export default __webpack_public_path__ + "static/media/DUDA_IKONE_08.8ad79d8f.svg";